import React from 'react'
import './App.css'

const Footer = () => {
  return (
    <footer className='footercontainer'></footer>
  )
}

export default Footer